export const STATUS_UNRECEIVED = 'IS';

export const STATUS_BAD_DEBT = 'BD';

export const STATUS_BAD_DEBT_PENDING = 'BP';

export const STATUS_LIABILITY = 'LB';
